import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Student } from '../models/student.model';

@Injectable({
    providedIn: 'root'
})
export class StudentService {

    private apiURL: string;

    studentsCountActive: number;
    studentsCountActiveData  = new Subject<number>();
    studentsCountActiveData$ = this.studentsCountActiveData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/student';

    }

    public get() {

        const url = this.apiURL;
        return this.http.get<Student[]>(url);

    }

    public getById(studentId: number) {

        const url = `${this.apiURL}/${studentId}`;
        return this.http.get<Student>(url);

    }

    public post(student: Student) {

        const url = this.apiURL;
        return this.http.post<boolean>(url, JSON.stringify(student));

    }

    public put(student: Student) {

        const url = this.apiURL;
        return this.http.put<boolean>(url, JSON.stringify(student));

    }

    public delete(studentId: number) {

        const url = `${this.apiURL}/disable/${studentId}`;
        return this.http.put<boolean>(url, null);

    }

    public enable(studentId: number) {

        const url = `${this.apiURL}/enable/${studentId}`;
        return this.http.put<boolean>(url, null);

    }

    getStudentCount() {

        const url = this.apiURL + '/getStudentCount';
        return this.http.get<number>(url).pipe(
            map((data) => {
                this.studentsCountActive = data;
                this.studentsCountActiveData.next();
            })
        );

    }

}
